import React, {Component} from "react"
import defaultUserImage from '../images/neeuro_logo_square.jpg'
import moment from 'moment'

class AccountLogo extends Component {
  render() {

    const sizeMap = {
      xxl: 128,
      xl: 96,
      lg: 64,
      md: 48,
      sm: 32
    }

    const profileImagePath = this.props.path? this.props.path : defaultUserImage
    const size = this.props.size || 'lg'

    return (
      <img src={profileImagePath.startsWith('http') ? profileImagePath + '?' + moment().milliseconds() : profileImagePath}
           className="img-rounded image" style={{height:sizeMap[size], width:sizeMap[size]}}/>
    )
  }
}

export default AccountLogo



// WEBPACK FOOTER //
// ./src/components/AccountLogo.js